import { useEffect } from "react";

/**
 * NpfWidget — NoPaperForms enquiry-form widget.
 *
 * React equivalent of the vendor's inline snippet: injects
 * https://widgets.in4.nopaperforms.com/emwgts.js, which renders the NPF enquiry
 * widget (used in the admission + contact page hero flow). Loaded once per
 * session so navigating between pages that mount it never duplicates the widget.
 */
const NPF_WIDGET_SRC = "https://widgets.in4.nopaperforms.com/emwgts.js";

const NpfWidget = () => {
  useEffect(() => {
    if (window._npfWidgetLoaded) return;
    window._npfWidgetLoaded = true;

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = NPF_WIDGET_SRC;
    s.dataset.npfWidget = "true";
    document.body.appendChild(s);
  }, []);

  return null;
};

export default NpfWidget;
